import { useStaticQuery, graphql } from "gatsby"
import { IMediaItem, EMediaTypes } from "../../gatsby-graphql"

export interface GetMediaItemsParams {
  count?: number
  locale?: string | null
  categorySlug?: string | null
}

/**
 * Queries and filters media items
 */
export const getMediaItems = ({
  count = 30,
  locale = null,
  categorySlug = null,
}: GetMediaItemsParams): IMediaItem[] => {
  // query all media items, since parameters in static queries are not available
  let { mediaItems } = useStaticQuery(graphql`
    query MediaQuery {
      mediaItems: allStrapiMediaItem {
        nodes {
          ...FMediaItem
        }
      }
    }
  `)

  const filterMediaItems = (mediaItem: IMediaItem) => {
    if (locale && locale !== mediaItem.locale) {
      return false
    }
    if (categorySlug && categorySlug !== mediaItem.category?.slug) {
      return false
    }

    return true
  }

  return mediaItems.nodes.filter(filterMediaItems).slice(0, count || 30)
}

/**
 * Returns the media type based on it's mime
 */
export const getMediaType = (mime: string): EMediaTypes => {
  if (!mime) {
    return "FILE"
  }

  const type = mime.split(/[\s/]+/)[0].toUpperCase()

  if (type === "IMAGE" || type === "VIDEO") {
    return type
  }

  return "FILE"
}
